var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g3, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g4, _g5, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarlogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 268.467,
    height: 196.128,
    viewBox: "0 0 268.467 196.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -211.713,
    y1: 0.975,
    x2: -211.008,
    y2: 0.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -301.914,
    y1: 0.812,
    x2: -302.41,
    y2: 0.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -898.031,
    y1: 0.441,
    x2: -899.214,
    y2: 0.585,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#babbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c9cbd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#d2d4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#c0c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -722.671,
    y1: 0.568,
    x2: -723.44,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -368.374,
    y1: 0.721,
    x2: -368.601,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -223.392,
    y1: 0.975,
    x2: -222.687,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -318.577,
    y1: 0.812,
    x2: -319.073,
    y2: 0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -947.427,
    y1: 0.441,
    x2: -948.611,
    y2: 0.585,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -762.384,
    y1: 0.568,
    x2: -763.154,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -388.714,
    y1: 0.721,
    x2: -388.941,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M183.448,407.751,328.967,492.6s14.869,7.511,29.608,8.48,27.541-5.591,36.488-9.675,29.543-15.939,33.819-19.935,16-12.431,4.4-23.8S248.742,347.634,233.366,347.008s-62.249,38.7-63.434,45.545C168.807,399.066,174.786,402.749,183.448,407.751Z",
    transform: "translate(-169.797 -305.052)",
    opacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M306.182,400.339l-4.757-.472s-19.839,13.734-35.8,19.974,2.1-7.471,7.242-10.986,32.5-16.789,33.319-14.666S306.182,400.339,306.182,400.339Z",
    transform: "translate(-50.448 -242.343)",
    fill: "#9099af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M183.584,392l13.576-8.858L234.337,407.5l72.509,57.126,9.507-8.073,31.037,18.459,2.039-54.711L183.584,349.538S169.638,357.593,183.584,392Z",
    transform: "translate(-159.663 -301.664)",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M214.054,386.978c0,9.2-6.5,12.91-14.524,8.279s-14.521-15.846-14.521-25.049,6.5-12.91,14.521-8.281S214.054,377.772,214.054,386.978Z",
    transform: "translate(-149.483 -287.782)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M203.451,401.149l9.411-5.432-20.67-35.348-9.466,5.464Z",
    transform: "translate(-152.532 -287.2)",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M209.98,389.328c0,9.206-6.5,12.915-14.524,8.281s-14.521-15.846-14.521-25.049,6.5-12.912,14.521-8.279S209.98,380.127,209.98,389.328Z",
    transform: "translate(-154.923 -284.642)",
    fill: "#3e3e3e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M266.834,417.448c0,9.206-6.5,12.912-14.524,8.281s-14.521-15.846-14.521-25.049,6.5-12.912,14.521-8.279S266.834,408.247,266.834,417.448Z",
    transform: "translate(-79.001 -247.091)",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M256.231,431.621l9.41-5.43-20.669-35.35-9.466,5.467Z",
    transform: "translate(-82.051 -246.509)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(6.626)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M261.134,366.684a5.527,5.527,0,0,0,.175,1.574c0,.026.012.037.012.058a1,1,0,0,0,.222.385,2.069,2.069,0,0,0,.278.234,5.175,5.175,0,0,0,2.158.955,3.926,3.926,0,0,0,1.051.049h.012a.619.619,0,0,0,.2-.023h.012a3.489,3.489,0,0,0,1.163-.362c.084-.047.177-.093.271-.152h.012c.093-.047.185-.107.278-.163,0,0,.014,0,.014-.012a13.754,13.754,0,0,0,4.664-4.909,4.717,4.717,0,0,0,.3-.806,5.769,5.769,0,0,0,.2-1.013,1.939,1.939,0,0,0,.023-.245,6.741,6.741,0,0,0,.047-.815,4.861,4.861,0,0,0-.023-.6,1.779,1.779,0,0,0-.035-.35,5.628,5.628,0,0,0-.21-1.107.1.1,0,0,0-.012-.035,3.437,3.437,0,0,0-.979-1.784,1.659,1.659,0,0,0-1.364-.374c-1.154.14-2.835,1.154-5.668,3.078a6.9,6.9,0,0,0-2.634,3.454l-.037.105a3.625,3.625,0,0,0-.079.591c0,.271-.023.584-.035.9v.012C261.134,365.775,261.122,366.242,261.134,366.684Z",
    transform: "translate(-54.46 -291.467)",
    fill: "#eeeef0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M262.12,364.83v.383l.009.012a.123.123,0,0,0,0,.082,6,6,0,0,0,.42,2.263v.012l.012.012a2.005,2.005,0,0,0,.99,1.13,2.185,2.185,0,0,0,1.8-.105v-.009a2.6,2.6,0,0,0,.3-.14s.014,0,.014-.012a10.659,10.659,0,0,0,4.664-4.909,4.713,4.713,0,0,0,.3-.806,4.548,4.548,0,0,0,.2-.946v-.068a1.925,1.925,0,0,0,.023-.245,6.747,6.747,0,0,0,.047-.815,4.826,4.826,0,0,0-.023-.6,1.385,1.385,0,0,0-.023-.315v-.009a4.5,4.5,0,0,0-.222-1.133.1.1,0,0,0-.012-.035c-.175-.488-.42-.771-.675-.817a1.909,1.909,0,0,0-.56.023,9.1,9.1,0,0,0-3.779,1.843C264.206,360.82,262.167,362.184,262.12,364.83Z",
    transform: "translate(-53.137 -290.697)",
    fill: "#efeef0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(68.464 0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M393.67,473.525a4.224,4.224,0,0,1-2.786.932c-1.284-.25-10.939-5.862-10.939-5.862l-.493-.266v-4.262c0-10.528-7.44-23.359-16.614-28.655-7.408-4.278-13.681-2.338-15.824,4.108a17.024,17.024,0,0,0-.789,5.364v5.661l-1.4-.747L256.191,398.62V392.9a28.214,28.214,0,0,0-1.261-8.017c-2.494-8.351-8.428-16.637-15.353-20.635-9.176-5.3-16.614-1.056-16.614,9.47v3.627L206.4,364.28l-2.84-7.3v-3.321l.591-1.2v-2.459l-.967-1.233-1.238-3.529,2.2-2.912s.374-5.932.642-7.378c.182-.983-.206-2.49.474-3.832l0,0a7.13,7.13,0,0,1,1.987-1.81.677.677,0,0,1,.215.03c1.6.392,14.066,4.341,14.066,4.341s2.574.5,7.361,1.217,20,1.726,24,2.968,19.22,8.23,34.87,17.835,22.172,16.287,24.012,18c10.883,10.1,29.367,30.026,31.8,32.99,4.288,3.293,39.017,26.5,43.662,37.464,1.072,3.158,3.571,12.964,3.571,12.964l1.929,3.407v2.216l-1.214,1.677.859,5.988Z",
    transform: "translate(-201.95 -329.306)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M393.67,467.514a4.224,4.224,0,0,1-2.786.932c-1.284-.25-10.939-5.862-10.939-5.862l-.493-.266v-4.262c0-10.528-7.44-23.359-16.614-28.655-7.408-4.278-13.681-2.338-15.824,4.108a17.024,17.024,0,0,0-.789,5.364v5.661l-1.4-.747-88.637-51.177V386.89a28.213,28.213,0,0,0-1.261-8.017c-2.494-8.351-8.428-16.637-15.353-20.635-9.176-5.3-16.614-1.056-16.614,9.47v3.627L206.4,358.27l-2.84-7.3v-3.321l.591-1.2V344l-.967-1.233-1.238-2.419s5.724,1.544,6.224,1.093,10.217-7.875,11.5-7.623,36.518,21.668,50.3,29.862,66.526,41.432,85.592,54.382c21.789,14.8,21.789,22.987,26.518,31.663.411.75,9.437,8.683,9.437,8.683l.859,5.988Z",
    transform: "translate(-201.95 -323.295)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M222.975,339.938c-7.5-2.938-12.363.079-12.578,12.583,9.148-5.626,11.649-7.328,20.152-.191a83.48,83.48,0,0,1,14.575,16.637S242.053,347.92,222.975,339.938Z",
    transform: "translate(-190.67 -316.496)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M316.72,410.536a17.025,17.025,0,0,0-.789,5.364v5.661l-1.4-.747L225.9,369.637v-5.719a28.214,28.214,0,0,0-1.261-8.017c.444-1.649.724-2.684.724-2.684a8.334,8.334,0,0,1,.75-.423,15.344,15.344,0,0,1,11.684-1.07c6.752,2.24,66.236,40.517,70.631,43.73,3.192,2.335,5.369,1.908,7.181,9.236C315.991,406.253,316.363,408.166,316.72,410.536Z",
    transform: "translate(-171.656 -300.323)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M242.29,360.017l-13.718-3.125,4.823,4.876,69.69,41.9s-6.742-8.076-10.885-10.558S242.29,360.017,242.29,360.017Z",
    transform: "translate(-166.4 -292.469)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M255.269,382.794v-5.719a28.216,28.216,0,0,0-1.261-8.017c-2.494-8.351-8.428-16.637-15.353-20.635-9.176-5.3-16.614-1.056-16.614,9.47v3.627l-16.56-13.064-2.84-7.3,2.894,2.933,13.786,9.587c1.14-10.434,9.36-14.293,19.335-8.536,7.179,4.148,13.452,12.226,16.826,20.811a35.463,35.463,0,0,1,2.644,12.775v1.754l84.319,50.106v-3.178a16.577,16.577,0,0,1,2.534-9.559c3.344-4.83,9.678-5.733,16.939-1.541,10.752,6.207,19.47,21.243,19.47,33.585l.355,1.432,11.007,6.376a4.224,4.224,0,0,1-2.786.932c-1.285-.25-10.939-5.862-10.939-5.862l-.493-.266v-4.262c0-10.528-7.44-23.358-16.614-28.655-7.408-4.278-13.681-2.338-15.824,4.108a17.024,17.024,0,0,0-.789,5.364v5.661l-1.4-.747Z",
    transform: "translate(-201.027 -313.481)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M241.429,347.452c24.286,15.266,97.11,61.827,97.11,61.827s27.754,17.336,32.2,22.179,10.633,16.5,11.7,18.41,6.471,7.228,6.471,7.228-2.5-9.806-3.571-12.964c-4.645-10.967-39.374-34.171-43.662-37.464-2.431-2.964-20.916-22.891-31.8-32.989-1.84-1.71-8.365-8.386-24.012-18S255,339.091,251,337.846s-19.215-2.254-24-2.968-7.361-1.217-7.361-1.217-12.462-3.949-14.066-4.341a23.374,23.374,0,0,1-2.2,1.78l0,0A140.909,140.909,0,0,1,241.429,347.452Z",
    transform: "translate(-200.055 -329.288)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M240.89,371.485c0,9.2-6.5,12.91-14.524,8.279s-14.524-15.846-14.524-25.049,6.5-12.91,14.524-8.279S240.89,362.281,240.89,371.485Z",
    transform: "translate(-188.739 -309.095)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M235.751,367.2c0,7.132-5.04,10-11.254,6.415s-11.254-12.279-11.254-19.409,5.037-10.007,11.254-6.42S235.751,360.063,235.751,367.2Z",
    transform: "translate(-186.87 -306.695)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M293.668,401.957c0,9.2-6.5,12.912-14.521,8.279s-14.524-15.846-14.524-25.047,6.5-12.912,14.524-8.281S293.668,392.753,293.668,401.957Z",
    transform: "translate(-118.258 -268.404)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M288.533,397.668c0,7.13-5.04,10-11.254,6.418s-11.257-12.279-11.257-19.414,5.04-10,11.257-6.415S288.533,390.536,288.533,397.668Z",
    transform: "translate(-116.39 -266.002)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(40.629 17.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M316.324,432.76l-.439-.264c-.677-.4-67.679-40.509-71.988-43.06-4.183-2.471-6.207-6.808-7.181-8.891l-.168-.362c-.852-1.791-10.509-24.491-10.918-25.458l-6.282-15.972.5-1.831,7.875,1,.063.04,82.607,51.878,3.365,6.49,2.525,6.712s1.049,9.159,1.478,12.77-1.287,15.918-1.359,16.439Zm-96.262-94.043,6.2,15.752c.1.226,10.059,23.646,10.9,25.423l.173.367c.943,2.02,2.91,6.228,6.91,8.594,4.127,2.438,65.689,39.288,71.549,42.8.327-2.405,1.658-12.639,1.289-15.757-.413-3.466-1.4-12.057-1.474-12.73l-2.473-6.553-3.265-6.289-82.385-51.74-7.142-.906Z",
    transform: "translate(-219.347 -336.923)",
    fill: "#878788"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M276.279,374.14l9.587,6.336s.9,3.734,1.866,6.875,1.77,7.539,1.77,7.539-4.173-4.886-4.334-5.348-7.77-13.526-7.77-13.526Z",
    transform: "translate(-102.693 -269.436)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M203.58,331.152l5.907,1.386,8.939,3.729-1.566,2.075-4.356,2.935-7-2.609-2.608-1.934-.49-3.879Z",
    transform: "translate(-201.342 -326.841)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M218.755,354.6s-13.435-9.4-14.22-10.18-1.894-2.074-1.894-2.074v-2.606l4.18,3.459,5.145,4.2,1.144,1.889Z",
    transform: "translate(-201.027 -315.38)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M288.861,391.031a24.7,24.7,0,0,1-5.607-2.947c-3.146-2.144-3.512-6.74-3.512-6.74l7.191,6.28Z",
    transform: "translate(-98.07 -259.816)",
    fill: "#efeef0"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M265.047,334.9l-72.183,41.674-7.361-1.218-10.624-6.488L243.4,329.307l14.28,4.372Z",
    transform: "translate(-169.637 -328.681)",
    fill: "#efeef0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M254.763,331.7l24,2.967-63.5,36.664-32.684,2.044Z",
    transform: "translate(-159.353 -325.484)",
    fill: "#efeef0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M317.087,381.3l-69.7,40.242-25.6-36.57,63.5-36.661Z",
    transform: "translate(-106.995 -303.299)",
    fill: "#efeef0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M255.457,405.463l63.5-36.661-20.317-14.717-38.565-21.114-63.5,36.664Z",
    transform: "translate(-140.664 -323.788)",
    fill: "#efeef0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M302.451,362.44l-69.7,40.242,44.9,36.748L346.113,399.9l-5.129-8.144Z",
    transform: "translate(-92.359 -284.436)",
    fill: "#efeef0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M257.855,437.92l68.462-39.526.021-1.318-.912-11.508-69.714,43.243-3.323,2.42Z",
    transform: "translate(-66.132 -253.551)",
    fill: "#d2d3d4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 40.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M364.357,490.447a4.221,4.221,0,0,1-2.786.934c-1.287-.252-14.659-3.713-14.659-3.713l-.5-.266V483.14c0-10.528-7.438-23.356-16.614-28.655-7.408-4.276-13.678-2.338-15.822,4.108a16.96,16.96,0,0,0-.789,5.364v5.661l-1.4-.75-88.639-51.175v-5.717a28.193,28.193,0,0,0-1.261-8.02c-2.492-8.351-8.428-16.639-15.353-20.638-9.173-5.294-16.612-1.056-16.612,9.472v3.627l-14.08-14.5-2.84-7.3V371.3l.589-1.2v-2.461l-.964-1.233v-4.241l2.2-2.915s.376-5.932.642-7.377a23.408,23.408,0,0,1,1.717-4.549l0,0c.315-.631.6-1.067.747-1.1a.6.6,0,0,1,.212.03c1.607.395,10.348,6.49,10.348,6.49s2.571.5,7.359,1.217,28.683-3.286,32.686-2.043,19.222,8.227,34.87,17.838,22.172,16.282,24.012,17.992c10.881,10.1,23.165,33.606,25.6,36.57,4.288,3.3,40.257,25.785,44.9,36.747,1.072,3.16,3.573,12.966,3.573,12.966l1.929,3.41v2.214l-1.214,1.677.859,5.99Z",
    transform: "translate(-172.634 -346.231)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M364.357,483.208a4.221,4.221,0,0,1-2.786.934c-1.287-.252-14.659-3.713-14.659-3.713l-.5-.266V475.9c0-10.528-7.438-23.356-16.614-28.655-7.408-4.276-13.678-2.338-15.822,4.108a16.959,16.959,0,0,0-.789,5.364v5.661l-1.4-.75-88.639-51.175v-5.717a28.193,28.193,0,0,0-1.261-8.02c-2.492-8.351-8.428-16.639-15.353-20.638-9.173-5.294-16.612-1.056-16.612,9.472v3.627l-14.08-14.5-2.84-7.3v-3.321l.589-1.2v-2.462l-.964-1.233v-3.136s3.244,2.98,3.744,2.529,8.98-7.158,10.266-6.908,36.516,21.67,50.3,29.86,66.523,41.434,85.592,54.384c21.789,14.8,21.789,22.987,26.518,31.663.409.752,13.158,6.534,13.158,6.534l.859,5.99Z",
    transform: "translate(-172.634 -338.992)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M285.813,428.382a16.961,16.961,0,0,0-.789,5.364v5.661l-1.4-.75-88.639-51.175v-5.717a28.192,28.192,0,0,0-1.261-8.02c.444-1.651.726-2.683.726-2.683a8.316,8.316,0,0,1,.747-.425,15.359,15.359,0,0,1,11.684-1.067c6.754,2.237,66.238,40.516,70.631,43.73,3.195,2.335,5.369,1.908,7.184,9.236C285.085,424.1,285.453,426.014,285.813,428.382Z",
    transform: "translate(-144.467 -316.02)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M194.2,357.608c-7.5-2.938-15.108,4.157-15.322,16.658,6.882-10.145,12.289-10.427,21.586-4.362,12.272,8.008,16.91,25.257,16.91,25.257S219.169,368.8,194.2,357.608Z",
    transform: "translate(-164.301 -331.921)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M211.383,377.859l-13.72-3.122,4.823,4.874,69.692,41.9s-6.745-8.076-10.888-10.561S211.383,377.859,211.383,377.859Z",
    transform: "translate(-139.211 -308.165)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M222.94,401.458v-5.717a28.191,28.191,0,0,0-1.261-8.02c-2.492-8.351-8.428-16.639-15.353-20.638-9.173-5.294-16.612-1.056-16.612,9.472v3.627l-10.808-9.643-3.272-4.853-2.84-7.3,4.18,6.457,10.016,7.494c1.14-10.435,9.362-14.295,19.335-8.533,7.179,4.143,13.452,12.221,16.826,20.806A35.438,35.438,0,0,1,225.8,397.39v1.754l84.319,50.106v-3.179a16.576,16.576,0,0,1,2.534-9.559c3.342-4.827,9.678-5.733,16.936-1.541,10.754,6.207,19.47,21.243,19.47,33.585l.355,1.434s8.993,4.222,14.276,4.015c.649-.026-1.023,1.135-2.333,1.142-5.8.03-14.659-3.713-14.659-3.713l-.5-.266V466.9c0-10.528-7.438-23.356-16.614-28.655-7.408-4.276-13.678-2.338-15.822,4.108a16.959,16.959,0,0,0-.789,5.364v5.661l-1.4-.75Z",
    transform: "translate(-172.419 -329.996)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M207.684,366.526c24.286,15.269,97.11,61.824,97.11,61.824s27.754,17.336,32.2,22.181,12.207,17.448,13.279,19.358,8.62,4.131,8.62,4.131-2.5-9.806-3.573-12.966c-4.645-10.962-40.615-33.452-44.9-36.747-2.431-2.964-14.715-26.471-25.6-36.57-1.84-1.71-8.363-8.384-24.012-17.992s-30.869-16.593-34.87-17.838-27.9,2.758-32.686,2.043-7.359-1.217-7.359-1.217-8.741-6.1-10.348-6.49c-.6.64-.927,1.028-.96,1.065l0,0S188.9,354.713,207.684,366.526Z",
    transform: "translate(-170.029 -346.212)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(19.386 37.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M209.98,389.328c0,9.206-6.5,12.915-14.521,8.281s-14.524-15.846-14.524-25.049,6.5-12.91,14.524-8.279S209.98,380.126,209.98,389.328Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M209.98,389.328c0,9.206-6.5,12.915-14.521,8.281s-14.524-15.846-14.524-25.049,6.5-12.91,14.524-8.279S209.98,380.126,209.98,389.328Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M208.96,388.67c0,8.853-6.254,12.419-13.97,7.966s-13.97-15.243-13.97-24.1,6.254-12.422,13.97-7.966S208.96,379.816,208.96,388.67Z",
    transform: "translate(-180.821 -361.794)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M205.746,385.991c0,7.541-5.327,10.579-11.9,6.787s-11.9-12.982-11.9-20.523,5.327-10.574,11.9-6.782S205.746,378.454,205.746,385.991Z",
    transform: "translate(-179.578 -360.212)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(3.244 3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M204.874,384.993c0,7.146-5.047,10.023-11.275,6.429s-11.275-12.3-11.275-19.449,5.049-10.023,11.275-6.427S204.874,377.849,204.874,384.993Z",
    transform: "translate(-182.324 -363.998)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M182.732,373.611a24.124,24.124,0,0,0,5.771,12.508c3.244,3.716,6.91,5.589,9.855,5.406a5.089,5.089,0,0,0,3.37-1.488,4.526,4.526,0,0,0,.8-1c.049-.077.1-.145.138-.222a5.646,5.646,0,0,0,.425-.878,8.98,8.98,0,0,0,.4-1.285,11.536,11.536,0,0,0,.271-2.578c0-.413-.021-.838-.058-1.263-.012-.22-.04-.432-.068-.647l-.058-.432c-.019-.135-.037-.273-.068-.406-.068-.4-.145-.822-.25-1.238-.049-.2-.1-.395-.156-.6a3.886,3.886,0,0,0-.145-.5c-.065-.243-.145-.493-.231-.736-.058-.182-.117-.367-.182-.539a23.433,23.433,0,0,0-.986-2.326c-.077-.166-.154-.318-.231-.472-.271-.523-.551-1.035-.859-1.546-.077-.124-.154-.25-.231-.376-.145-.231-.3-.462-.444-.687a25.237,25.237,0,0,0-1.9-2.5c-.348-.395-.7-.771-1.053-1.119-.163-.175-.339-.339-.5-.493-.049-.049-.105-.1-.154-.145-.135-.126-.278-.25-.416-.367a14.1,14.1,0,0,0-5.019-2.936c-2.856-.857-5.413-.192-6.882,2.144-.047.068-.1.145-.135.213a7.436,7.436,0,0,0-.666,1.544A12.194,12.194,0,0,0,182.732,373.611Z",
    transform: "translate(-181.922 -363.475)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M195.958,370.182l.105,3.167c1.189-.1,2.366-.212,3.466-.357-.145-.231-.3-.462-.444-.687a25.235,25.235,0,0,0-1.9-2.5c-.348-.395-.7-.771-1.053-1.119-.163-.175-.339-.339-.5-.493-.049-.049-.105-.1-.154-.145-.135-.126-.278-.25-.416-.367a14.1,14.1,0,0,0-5.019-2.936c-2.856-.857-5.413-.192-6.882,2.144A11.387,11.387,0,0,1,195.958,370.182Z",
    transform: "translate(-181.21 -363.475)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M182.96,368.436s2.732,3.622,5.539,4.577,8.244,7.529,8.244,7.529l-.416-12.317C189.908,368.709,182.96,368.436,182.96,368.436Z",
    transform: "translate(-181.475 -358.351)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M185.421,371.232a20.666,20.666,0,0,0,4.96,10.745,15.09,15.09,0,0,0,4.787,3.8v.012a7.587,7.587,0,0,0,3.669.829,1.228,1.228,0,0,0,.259-.03,3.456,3.456,0,0,0,.782-.145,11.533,11.533,0,0,0,.271-2.578c0-.413-.021-.838-.058-1.263-.012-.219-.04-.432-.068-.647l-.058-.432c-.019-.135-.037-.273-.068-.406-.068-.4-.145-.822-.25-1.238-.049-.2-.1-.395-.156-.6a3.9,3.9,0,0,0-.145-.5c-.065-.243-.145-.493-.231-.736-.058-.182-.117-.367-.182-.54a23.442,23.442,0,0,0-.986-2.326c-.077-.166-.154-.318-.231-.472-.271-.523-.551-1.035-.859-1.546-.212-.357-.444-.712-.675-1.063a25.242,25.242,0,0,0-1.9-2.5c-.348-.395-.7-.771-1.053-1.119-.163-.175-.339-.339-.5-.493-.049-.049-.105-.1-.154-.145-.135-.126-.278-.25-.416-.367a14.1,14.1,0,0,0-5.019-2.936,5.183,5.183,0,0,0-.859,1.112,6.242,6.242,0,0,0-.567,1.322,9.55,9.55,0,0,0-.369,2.24A12.885,12.885,0,0,0,185.421,371.232Z",
    transform: "translate(-178.308 -363.27)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M189.8,375.261l-.264,2.471v.009l.264-2.48,1.927-1.119,1.4-2.868c-.213-.357-.444-.712-.675-1.063a25.258,25.258,0,0,0-1.9-2.5c-.348-.395-.7-.771-1.053-1.119-.164-.175-.339-.339-.5-.493-.049-.049-.105-.1-.154-.145-.376.222-.684.416-.705.434l2.412,2.772Z",
    transform: "translate(-174.571 -361.381)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M188.994,370.581l-.264,2.471v.009l1.9,6.149.85,2.77c.29.61-.57,1.99-.175,1.913a13.693,13.693,0,0,0,3.069-1.633c.049-.077.1-.145.138-.222a5.637,5.637,0,0,0,.425-.878,1.457,1.457,0,0,0-.147-.444l-.231-.7-3.475-10.229-.164-.329Z",
    transform: "translate(-173.77 -356.701)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M185.016,366.034a.648.648,0,0,1,.619.07l9.225,3.907.259.149.009,4.951-2.048-1.177-7.646-3a2,2,0,0,1-.9-1.492c-.049-1.081-1.716-1.319-1.511-2.254A12.6,12.6,0,0,1,185.016,366.034Z",
    transform: "translate(-181.41 -361.346)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(1.181 4.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M190.231,378.994l4.01-8.239a1.5,1.5,0,0,0-.292-1.464c-.378-.516-.782-1.021-1.205-1.506s-.855-.936-1.289-1.357c-.42-.4-.88-.441-1.077-.1l-4.008,8.242Z",
    transform: "translate(-178.101 -366.096)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M193.435,375.588l-.007-4.953-.259-.147-9.225-3.9c-.418-.241-.78-.119-.871.3a11.536,11.536,0,0,0-.227,3.041,2,2,0,0,0,.894,1.492l7.646,3Z",
    transform: "translate(-182.83 -365.61)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M194.648,382.454c.269-.213.278-.738.026-1.263l-3.709-10.923-.156-.327-3.438,1,1.238,2.59,2.758,8.928c.285.6.82,1.007,1.217.927A4.8,4.8,0,0,0,194.648,382.454Z",
    transform: "translate(-176.766 -360.962)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M262.76,419.8c0,9.2-6.5,12.91-14.524,8.281s-14.521-15.846-14.521-25.052,6.5-12.91,14.521-8.281S262.76,410.6,262.76,419.8Z",
    transform: "translate(-91.068 -284.101)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(142.647 108.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M262.76,419.8c0,9.2-6.5,12.91-14.524,8.281s-14.521-15.846-14.521-25.052,6.5-12.91,14.521-8.279S262.76,410.6,262.76,419.8Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M262.76,419.8c0,9.2-6.5,12.91-14.524,8.281s-14.521-15.846-14.521-25.052,6.5-12.91,14.521-8.279S262.76,410.6,262.76,419.8Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M261.74,419.144c0,8.853-6.254,12.417-13.97,7.964s-13.97-15.243-13.97-24.1,6.254-12.419,13.97-7.966S261.74,410.29,261.74,419.144Z",
    transform: "translate(-233.601 -392.266)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M258.524,416.464c0,7.539-5.325,10.577-11.9,6.782s-11.9-12.98-11.9-20.519,5.327-10.577,11.9-6.782S258.524,408.923,258.524,416.464Z",
    transform: "translate(-232.358 -390.684)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(3.244 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M257.654,415.467c0,7.146-5.047,10.023-11.275,6.429S235.1,409.591,235.1,402.447s5.049-10.023,11.275-6.429S257.654,408.321,257.654,415.467Z",
    transform: "translate(-235.104 -394.47)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M235.51,404.082a24.128,24.128,0,0,0,5.773,12.508c3.241,3.718,6.91,5.591,9.855,5.406a5.1,5.1,0,0,0,3.368-1.485,4.618,4.618,0,0,0,.8-1.007,1.824,1.824,0,0,0,.135-.222,5.873,5.873,0,0,0,.425-.878,8.859,8.859,0,0,0,.406-1.282,11.675,11.675,0,0,0,.269-2.578c0-.416-.019-.838-.056-1.263-.012-.224-.04-.434-.07-.647l-.056-.434c-.021-.136-.04-.271-.068-.406-.068-.4-.145-.82-.252-1.235-.047-.2-.1-.395-.154-.6a4.121,4.121,0,0,0-.145-.5c-.068-.241-.145-.493-.231-.733-.058-.182-.117-.367-.185-.542a23.153,23.153,0,0,0-.983-2.326c-.077-.164-.154-.318-.231-.472-.271-.521-.551-1.032-.859-1.546-.077-.126-.156-.25-.231-.376-.145-.231-.3-.462-.444-.684a24.891,24.891,0,0,0-1.9-2.5c-.348-.4-.7-.773-1.051-1.121-.166-.173-.339-.336-.5-.493-.049-.047-.107-.1-.154-.142-.135-.128-.28-.255-.416-.367a14.115,14.115,0,0,0-5.019-2.936c-2.856-.859-5.416-.194-6.882,2.144a1.714,1.714,0,0,0-.135.212,7.266,7.266,0,0,0-.666,1.544A12.223,12.223,0,0,0,235.51,404.082Z",
    transform: "translate(-234.702 -393.947)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M248.736,400.656l.107,3.164c1.186-.1,2.363-.21,3.466-.357-.145-.231-.3-.462-.444-.684a24.891,24.891,0,0,0-1.9-2.5c-.348-.4-.7-.773-1.051-1.121-.166-.173-.339-.336-.5-.493-.049-.047-.108-.1-.154-.142-.135-.128-.28-.255-.416-.367a14.115,14.115,0,0,0-5.019-2.936c-2.856-.859-5.416-.194-6.882,2.144A11.382,11.382,0,0,1,248.736,400.656Z",
    transform: "translate(-233.99 -393.947)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M235.74,398.911s2.73,3.62,5.539,4.575,8.244,7.529,8.244,7.529l-.416-12.317C242.688,399.181,235.74,398.911,235.74,398.911Z",
    transform: "translate(-234.255 -388.824)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M238.2,401.7a20.694,20.694,0,0,0,4.96,10.745,15.165,15.165,0,0,0,4.788,3.8v.009a7.543,7.543,0,0,0,3.669.831,1.11,1.11,0,0,0,.262-.03,3.5,3.5,0,0,0,.782-.142,11.671,11.671,0,0,0,.269-2.578c0-.416-.019-.838-.056-1.263-.012-.224-.04-.434-.07-.647l-.056-.434c-.021-.135-.04-.271-.068-.406-.068-.4-.145-.82-.252-1.235-.047-.2-.1-.395-.154-.6a4.125,4.125,0,0,0-.145-.5c-.068-.241-.145-.493-.231-.733-.058-.182-.117-.367-.185-.542a23.153,23.153,0,0,0-.983-2.326c-.077-.163-.154-.318-.231-.472-.271-.521-.551-1.032-.859-1.546-.213-.355-.446-.715-.675-1.06a24.91,24.91,0,0,0-1.9-2.5c-.348-.4-.7-.773-1.051-1.121-.166-.173-.339-.336-.5-.493-.049-.047-.107-.1-.154-.142-.135-.128-.28-.255-.416-.367a14.114,14.114,0,0,0-5.019-2.936,4.968,4.968,0,0,0-.859,1.109,6.277,6.277,0,0,0-.57,1.324,9.535,9.535,0,0,0-.367,2.237A12.9,12.9,0,0,0,238.2,401.7Z",
    transform: "translate(-231.089 -393.741)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M242.573,405.729l-.264,2.476v.009l.264-2.485,1.927-1.116,1.4-2.868c-.213-.355-.446-.715-.675-1.06a24.9,24.9,0,0,0-1.9-2.5c-.348-.4-.7-.773-1.051-1.121-.166-.173-.339-.336-.5-.493-.049-.047-.107-.1-.154-.142-.376.222-.687.413-.705.432l2.41,2.775Z",
    transform: "translate(-227.351 -391.853)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M241.773,401.05l-.264,2.476v.009l1.9,6.147.852,2.772c.287.607-.572,1.99-.175,1.91a13.655,13.655,0,0,0,3.069-1.633,1.822,1.822,0,0,0,.135-.222,5.852,5.852,0,0,0,.425-.878,1.388,1.388,0,0,0-.145-.444l-.231-.7-3.477-10.231-.163-.327Z",
    transform: "translate(-226.551 -387.174)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M237.795,396.508a.64.64,0,0,1,.621.07l9.225,3.9.259.147.007,4.953-2.048-1.179-7.646-3a2,2,0,0,1-.895-1.49c-.051-1.084-1.719-1.32-1.513-2.254A12.634,12.634,0,0,1,237.795,396.508Z",
    transform: "translate(-234.191 -391.819)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(1.181 4.901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M243.013,409.465l4.008-8.237a1.5,1.5,0,0,0-.29-1.467q-.571-.774-1.2-1.5t-1.292-1.357c-.42-.4-.878-.441-1.074-.1l-4.01,8.237Z",
    transform: "translate(-230.882 -396.569)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M246.215,406.063l-.009-4.953-.257-.149-9.227-3.907c-.416-.238-.78-.114-.871.3a11.57,11.57,0,0,0-.224,3.043,1.986,1.986,0,0,0,.894,1.495l7.646,3Z",
    transform: "translate(-235.61 -396.083)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M247.428,412.927c.269-.21.278-.738.026-1.261l-3.709-10.925-.159-.329-3.435,1L241.389,404l2.756,8.928c.287.6.822,1.007,1.219.929A4.841,4.841,0,0,0,247.428,412.927Z",
    transform: "translate(-229.545 -391.437)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(37.443 19.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M285.06,450.769l-.3-.18c-.7-.418-69.615-41.565-73.768-44.37-1.1-.743-4.486-6.675-4.778-8.7-3.066-21.042-16.485-30.93-16.621-31.025l-.056-.04-.869-4.722,0-.028.768-5.8,1.623-1.432,5.378,1.854,82.565,51.845,7.167,5.733-1.488,2.585-1.035,4.066a94.986,94.986,0,0,0-.705,10.906c.257,5.581,2.048,18.821,2.067,18.956Zm-95.213-84.508c.958.722,13.716,10.719,16.7,31.212.28,1.927,3.61,7.772,4.636,8.463,4,2.7,68.443,41.191,73.448,44.178-.287-2.142-1.789-13.55-2.022-18.636a94.628,94.628,0,0,1,.71-10.983l1.063-4.15,1.355-2.354-6.924-5.542-82.516-51.817-5.157-1.772-1.376,1.217-.75,5.647Z",
    transform: "translate(-188.667 -354.474)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M174.8,347.771l1.077,2.774,2.8,2.966,4.437,4.313L180,360.043l-2.3-1.439a7.417,7.417,0,0,1-3.024-3.718l-.568-1.534-.49-3.879Z",
    transform: "translate(-171.316 -344.175)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M186.429,373.256s-10.955-10.827-11.742-11.607-1.892-2.079-1.892-2.079v-2.6l1.7,4.893,5.147,4.2,1.142,1.889Z",
    transform: "translate(-172.419 -331.895)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M261.674,406.73s-5.388-.168-8.531-2.31a12.338,12.338,0,0,1-4.311-5.231l10.913,4.131Z",
    transform: "translate(-70.881 -275.512)",
    fill: "#efeef0"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M255.547,430.973l68.463-39.526-3.572-12.965-68.463,39.526Z",
    transform: "translate(-66.683 -263.014)",
    fill: "#efeef0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M254.221,430.859l68.461-39.526,1.213-1.678v-2.215l-1.928-3.407L253.5,423.559l1.93,3.41v2.214Z",
    transform: "translate(-65.57 -256.529)",
    fill: "#efeef0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M233.708,400.555s4.587,4.148,9.6,3.428,17.338-5.733,34.029-14.851,25.187-18.307,26.121-20.687-2.286-4.888-2.286-4.888Z",
    transform: "translate(-91.077 -282.942)",
    fill: "#292929"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M283.067,348.645c-6.348,5.409-14.783,10.824-21.693,14.979-5.065,3.036-9.911,5.761-14.349,8.141-14.386,7.716-24.575,11.873-24.575,11.873l.023.03c.376.343,5.086,4.783,14.855,18.9,6.252,9.029,9.689,14.795,11.415,17.908v0a3.389,3.389,0,0,0,4.031,1c.075-.028.149-.054.224-.086.694-.294,1.217-.518,1.611-.687.128-.047.259-.1.388-.163a1.541,1.541,0,0,0,.2-.089l.565-.238.014-.007c8.8-3.814,18.783-8.849,26.749-13.122,4.444-2.377,8.258-4.519,10.895-6.077,7.845-4.643,18.337-11.752,21.932-16.277a8.656,8.656,0,0,0,.85-1.256A387.232,387.232,0,0,0,283.067,348.645Z",
    transform: "translate(-106.111 -302.857)",
    fill: "#37464e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M234.321,363.414c1.418,2.55,4.953,1.805,5.976,1.161,1.049-.658,9.769-5.581,11.086-6.59,1.128-.862-.04-3.592-.4-4.365-1.878,1.189-3.716,2.314-5.458,3.363C241.628,359.317,237.868,361.464,234.321,363.414Z",
    transform: "translate(-90.259 -296.215)",
    fill: "#131313"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M286.81,383.293l-1.932.1S265.586,371.053,243.552,357a126.2,126.2,0,0,0,11.165-8.291c1.95,1.889,4.1,4.071,6.45,6.6C272.422,367.4,286.81,383.293,286.81,383.293Z",
    transform: "translate(-77.932 -302.775)",
    fill: "#566770"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M302.089,365.576c-3.594,4.526-14.087,11.635-21.932,16.278-2.637,1.558-6.45,3.7-10.895,6.077-7.966,4.274-17.95,9.309-26.749,13.122l-.014.007-.565.238a1.548,1.548,0,0,1-.2.089c-.128.061-.259.117-.388.163-.395.168-.918.392-1.611.687-.075.033-.15.058-.224.086a3.39,3.39,0,0,1-4.031-1l-.346,1.114q-1.356-2.508-2.746-4.914c.49-.476,1.434-1.448,2.686-2.868,1.861-2.107,25.194-12.891,25.813-13.239.374-.213.747-.423,1.114-.631,21.436-12.156,25.635-16.511,28.3-17.536a3.487,3.487,0,0,1,1.331-.259,25.523,25.523,0,0,1,9.57,1.305Z",
    transform: "translate(-92.844 -283.706)",
    fill: "#63747d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M246.175,382.585l-1.425-.691s-.044-7.109.712-8.041,22.109-12.074,22.9-11.969,10.395,5.652,10.395,5.652Z",
    transform: "translate(-76.332 -285.178)",
    fill: "#63747d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M244.847,359.2l-3.365,1.943a59.152,59.152,0,0,0-5.561,3.645h0a2.154,2.154,0,0,0-.764,2.069l.418,1.959a.986.986,0,0,0,1.38.829h0a52.224,52.224,0,0,0,5.726-2.868l3.368-1.943a58.966,58.966,0,0,0,5.558-3.648h0a2.148,2.148,0,0,0,.764-2.067l-.418-1.959a.987.987,0,0,0-1.38-.831h0A52.831,52.831,0,0,0,244.847,359.2Z",
    transform: "translate(-89.194 -292.711)",
    fill: "#63747d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M241.656,360.648c-.037-.962-.245-3.618-.245-3.618l-3.349.072s.374,3.762.413,3.9c.189.612,1.007,1.289,1.359,1.254C240.657,362.173,241.7,361.687,241.656,360.648Z",
    transform: "translate(-85.263 -291.66)",
    fill: "#63747d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M241.131,357.085a1.407,1.407,0,0,1-.467,2.083,1.806,1.806,0,0,1-2.321-.465,1.41,1.41,0,0,1,.467-2.085A1.806,1.806,0,0,1,241.131,357.085Z",
    transform: "translate(-85.263 -292.523)",
    fill: "#63747d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M322.877,380.444c.6,2.177-13.755,13.58-18.253,16.943a176.752,176.752,0,0,1-15.9,10.021c-7.758,4.538-13.886,7.16-34.314,12.56-1.411.374-4.264-3.989-4.264-3.989l61.635-38.966Z",
    transform: "translate(-69.122 -264.975)",
    fill: "#efeef0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M263.35,396.669c-6.425.633-10.058-1.7-11.623-3.342s-2.45,1.726-2.45,1.726,4.08,7.006,7.45,7.006S263.35,396.669,263.35,396.669Z",
    transform: "translate(-70.287 -243.79)",
    fill: "#efeef0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M223.882,363.631s4.687,4.194,14.881,18.921,12.912,20.785,12.912,20.785l-3.741.269-13.758-22.924-12.8-16.161Z",
    transform: "translate(-107.545 -282.845)",
    fill: "#efeef0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M274.907,335.321c-16.889,7.034-19.608,8.136-30.4,14.421s-23.045,13.676-28.478,19.575c0,0-3.281-.227-8.045-.278-6.682-.082-16.285.175-23.842,1.861a63.878,63.878,0,0,1,8.291-7.728,199.581,199.581,0,0,1,22.768-15.8c11.726-7.223,26.71-12.952,30.266-14.381a14.593,14.593,0,0,1,2.882-.834,8.816,8.816,0,0,1,3.057-.089S269.626,333.3,274.907,335.321Z",
    transform: "translate(-157.269 -325.112)",
    fill: "#37464e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M174.8,369.425c1.294-2.387,2.555-5,5.187-6.924a217.994,217.994,0,0,1,23.307-16.226c15.717-9.769,29.309-16.161,32.964-16.959a16.763,16.763,0,0,1,7.471.381l-5.941,11.822Z",
    transform: "translate(-169.744 -329.039)",
    fill: "#efeef0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M282.53,393.86c-7.966,4.274-17.95,9.309-26.749,13.123l-.014.007-.565.238a1.528,1.528,0,0,1-.2.089c-.128.061-.259.117-.388.163-.395.168-.918.392-1.611.687-.075.033-.15.058-.224.086a3.39,3.39,0,0,1-4.031-1l-.346,1.114a225.519,225.519,0,0,0-25.948-37.945s10.189-4.157,24.575-11.873c2.167,1.572,10.955,8.23,23.639,21.885C275.925,386.091,279.765,390.514,282.53,393.86Z",
    transform: "translate(-106.111 -289.636)",
    fill: "#1c2121",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M324.5,393.272a3.766,3.766,0,0,1,0,.761,1.467,1.467,0,0,1-.065.329c.079,4.281-5.136,9.192-11.072,13.157-.014-.617-.014-.971-.026-1.179v-.29c.355-.5-1.1-2.707-1.446-2.6s-10.021,6.476-17.534,10.876-17.06,9.192-18.529,9.993c-.684.369-1.511.381-2.207,1.8-.7,1.394-1.247,2.812-1.4,3.2-.028.068-.04.105-.04.105a4.285,4.285,0,0,1-.448,1.315,38.841,38.841,0,0,1-4.61,1.852c-9.4,2.851-13.33,2.261-13.33,2.261l1.735-1.17h.012l67.243-45.1a15.355,15.355,0,0,1,1.681,4.465C324.474,393.128,324.489,393.207,324.5,393.272Z",
    transform: "translate(-64.258 -249.524)",
    fill: "#d2d3d4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M269.531,403.941a36.685,36.685,0,0,1-15.14,3.4c-.236,3.994,0,4.269,0,4.269s1.625.537,6.551-.661S268.931,408.593,269.531,403.941Z",
    transform: "translate(-63.598 -229.016)",
    fill: "#9099af"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M287.049,388.62c-.535,3.05-5.019,6.88-6.633,8.337a29.453,29.453,0,0,1,.107,4.991c3.529-2.873,5.906-5.934,6.06-6.541C287.067,393.51,287.231,392.642,287.049,388.62Z",
    transform: "translate(-28.705 -249.475)",
    fill: "#9099af"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M267.122,408.1a43.518,43.518,0,0,0,5.1-2.076c-.028.068-.04.105-.04.105a4.285,4.285,0,0,1-.448,1.315,38.825,38.825,0,0,1-4.61,1.852c-9.4,2.851-13.33,2.261-13.33,2.261l1.735-1.17h.012A47.793,47.793,0,0,0,267.122,408.1Z",
    transform: "translate(-64.258 -226.23)",
    fill: "#9099af"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M290.453,390.741a3.776,3.776,0,0,1,0,.761,1.468,1.468,0,0,1-.065.329c.079,4.281-5.135,9.192-11.072,13.157-.014-.616-.014-.972-.026-1.179,5.948-3.968,11.177-8.893,11.1-13.174.012-.04.012-.08.026-.119a.05.05,0,0,0,.012-.037A1.817,1.817,0,0,1,290.453,390.741Z",
    transform: "translate(-30.208 -246.993)",
    fill: "#9099af"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M253.811,434.043s10.115-1.756,17.307-4.757,6.693-2.728,18.015-8.9,33.711-19.253,34.353-27.548a14.426,14.426,0,0,0-3.718-11.191l.871,7.135-.589,3.526L279.33,417.847l-24.559,12.305Z",
    transform: "translate(-64.232 -258.784)",
    fill: "#e7e7e9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M254.222,429.756S264.334,428,271.527,425s6.7-2.73,18.017-8.9,32.515-18.545,33.158-26.84c.068-3.76-2.861-7.312-2.861-7.312l-1.226,10.523-8.966,5.565-35.8,21.128-16.481,7.184Z",
    transform: "translate(-63.683 -258.387)",
    fill: "#efeef0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M285,410.5s-7.982-6.78-16.817-12.961-26.908-16.994-26.908-16.994l1.107-.53s16.168,9.872,24.594,15.178a179.671,179.671,0,0,1,17.2,12.725A5.622,5.622,0,0,1,285,410.5Z",
    transform: "translate(-80.974 -260.973)",
    fill: "#e7e7e9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M295.178,402.788s-31.32-32.048-33.641-33.917c.906.056,29.989,28.837,31.121,30.187A33.828,33.828,0,0,1,295.178,402.788Z",
    transform: "translate(-53.915 -275.847)",
    fill: "#e7e7e9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M201.186,368.988c4.3-3.414,8.989-7.081,12.751-9.612a279.8,279.8,0,0,1,40.853-22.371l-6.443-4.951a14.6,14.6,0,0,0-2.882.834c-3.557,1.429-18.541,7.158-30.266,14.381a199.581,199.581,0,0,0-22.768,15.8,63.871,63.871,0,0,0-8.291,7.728c.292-.065.565-.122.831-.175A97.972,97.972,0,0,1,201.186,368.988Z",
    transform: "translate(-157.269 -325.012)",
    fill: "#63747d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(78.796 85.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M207.037,403.481l-.663-2.039.014-.047,1.492-5.572c-.023-.542-.369-9.211-.369-11.829,0-2.7.988-10.549,1-10.628l1.868-7.908.329.077-1.864,7.891c-.007.063-.99,7.891-.99,10.568s.364,11.749.367,11.84l0,.026-.007.023-1.485,5.549.631,1.943Z",
    transform: "translate(-206.374 -365.459)",
    fill: "#9099af"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M289.568,421.7l-5.5-.67s-70.5-45.075-94.781-60.344c0,0,14.694-9.97,15.764-10.458s5,0,16.31,5.477a303.55,303.55,0,0,1,28.3,16.336,92.568,92.568,0,0,1,20.089,18.1C277.34,399.543,289.568,421.7,289.568,421.7Z",
    transform: "translate(-150.393 -300.938)",
    fill: "#292929"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M282.647,417.9c-5.5-3.515-66.694-42.635-91.762-58.438,5.168-3.491,11.614-7.81,12.812-8.5l.124,0c1,0,4.433.53,14.521,5.42a300.06,300.06,0,0,1,28.046,16.194,88.763,88.763,0,0,1,19.641,17.686c5.6,6.934,13.9,21.172,17.655,27.77Z",
    transform: "translate(-148.262 -299.773)",
    fill: "#37464e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M213,356.555s-6.07,12.45-6.07,20.691l7.476,4.841s-.509-16.651,2.718-22.768A35.1,35.1,0,0,0,213,356.555Z",
    transform: "translate(-126.831 -292.294)",
    fill: "#292929"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M233.621,382.235a4.752,4.752,0,0,0,1.782-.612c.521-.425.133-1.994-.754-2.557s-3.377.684-3.788.474-2.938.855-2.938.855l.82,1.805Z",
    transform: "translate(-98.802 -262.43)",
    fill: "#eeeef0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M233.657,377.639c2.345-.586,4.734.18,5.049,2.84.383,3.23-1.037,3.744-1.894,4.148a20.3,20.3,0,0,1-8.113,1.847c-4.059.047-4.554-2.123-4.554-3.564,0-.208,0-.194.016-.385.114-2.058.857-2.669,2.237-3.08C229.381,378.554,233.657,377.639,233.657,377.639Z",
    transform: "translate(-103.847 -264.386)",
    fill: "#eeeef0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M236.8,378.193c-1.345-.42-4.134.124-6.873.717s-4.8.549-5.014,3.211.647,3.307,1.784,3.482a15.934,15.934,0,0,0,6.546-.787c3.249-.943,3.706-1.476,4.213-2.373S238.142,378.609,236.8,378.193Z",
    transform: "translate(-102.863 -263.598)",
    fill: "#efeef0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M247.428,384.391l11.436-5.563c.46-.224.416-.652-.1-.958h0a2.117,2.117,0,0,0-1.773-.145l-11.434,5.561c-.462.227-.416.656.1.958h0A2.1,2.1,0,0,0,247.428,384.391Z",
    transform: "translate(-75.68 -264.2)",
    fill: "#292929"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M258.768,379.076l9.36-6.966c.378-.28.3-.731-.164-1h0a1.513,1.513,0,0,0-1.532.016l-9.363,6.966c-.378.285-.3.731.164,1h0A1.517,1.517,0,0,0,258.768,379.076Z",
    transform: "translate(-60.203 -273.126)",
    fill: "#292929"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(84.138 93.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M209.643,369.171a4.011,4.011,0,0,0-.869,3.368c.367.964,7.078,5.056,7.751,5.222s1.17-1.691,1.074-2.263S209.643,369.171,209.643,369.171Z",
    transform: "translate(-208.662 -368.776)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M214.719,372.16l-4.577-2.91c-.593-.381-1.1-.119-1.128.579l-.009.241a2.421,2.421,0,0,0,1.018,1.945l6.3,4.005c.708.448,1.114-.315.654-1.228h0A6.719,6.719,0,0,0,214.719,372.16Z",
    transform: "translate(-208.832 -368.904)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M216.8,376.422a.9.9,0,0,1-.479-.161l-6.3-4a2.58,2.58,0,0,1-1.1-2.1l.009-.24a.836.836,0,0,1,1.39-.717l4.577,2.91a6.965,6.965,0,0,1,2.314,2.7,1.252,1.252,0,0,1-.028,1.462A.57.57,0,0,1,216.8,376.422Zm-7.081-7.078a.368.368,0,0,0-.182.042.6.6,0,0,0-.259.546l-.012.245a2.28,2.28,0,0,0,.941,1.794l6.3,4c.112.072.32.175.46.049.159-.15.2-.567-.049-1.058a6.6,6.6,0,0,0-2.193-2.564l-4.577-2.912A.832.832,0,0,0,209.723,369.343Z",
    transform: "translate(-208.929 -369.002)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M210.448,370.6c-.016.376-.287.516-.6.313a1.3,1.3,0,0,1-.549-1.046c.016-.374.287-.516.607-.313A1.309,1.309,0,0,1,210.448,370.6Z",
    transform: "translate(-208.443 -368.391)",
    fill: "#292929"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(41.389 66.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M191.339,357.588a4.006,4.006,0,0,0-.869,3.365c.369.967,7.079,5.056,7.751,5.222s1.17-1.691,1.072-2.263S191.339,357.588,191.339,357.588Z",
    transform: "translate(-190.357 -357.191)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M196.414,360.577l-4.58-2.912c-.591-.378-1.1-.117-1.126.581l-.009.241a2.421,2.421,0,0,0,1.018,1.945l6.3,4c.708.451,1.116-.315.654-1.228h0A6.727,6.727,0,0,0,196.414,360.577Z",
    transform: "translate(-190.527 -357.32)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M198.5,364.84a.878.878,0,0,1-.479-.163l-6.3-4a2.583,2.583,0,0,1-1.1-2.1l.012-.243a.834.834,0,0,1,1.387-.717l4.577,2.912a6.93,6.93,0,0,1,2.314,2.7,1.252,1.252,0,0,1-.028,1.462A.576.576,0,0,1,198.5,364.84Zm-7.081-7.079a.386.386,0,0,0-.182.04.607.607,0,0,0-.259.549l-.012.243a2.254,2.254,0,0,0,.941,1.8l6.3,4c.112.072.322.173.458.047.161-.147.2-.565-.047-1.056a6.6,6.6,0,0,0-2.2-2.567l-4.577-2.91A.811.811,0,0,0,191.418,357.761Z",
    transform: "translate(-190.624 -357.418)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M192.143,359.016c-.016.376-.287.516-.6.313a1.3,1.3,0,0,1-.549-1.046c.016-.376.287-.516.6-.313A1.3,1.3,0,0,1,192.143,359.016Z",
    transform: "translate(-190.138 -356.807)",
    fill: "#292929"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M178.751,348.648s.318,1.812,8.134,3.557,35.965-3.713,35.965-3.713l-32.567,1.151Z",
    transform: "translate(-164.466 -303.062)",
    fill: "#efeef0"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M251.771,403.363s6.394,2.959,12.845,1.116l6.453-1.843L257.014,407.6l-5.96-2.772Z",
    transform: "translate(-61.288 -230.757)",
    fill: "#d2d3d4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M298.532,384.287c-13.774,10.222-37.819,22.16-37.819,22.16s-3.891,13.041,4.113,10.236,35.15-19.092,37.42-21.775C303.856,388.446,298.532,384.287,298.532,384.287Z",
    transform: "translate(-49.652 -255.261)",
    fill: "rgba(179,179,179,0.85)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M262.064,410.182s24.045-11.938,37.819-22.16a11.93,11.93,0,0,1,2.543,3.034,11.647,11.647,0,0,0-3.9-6.768c-13.774,10.222-37.819,22.16-37.819,22.16s-2.38,7.978.416,10.115A24.234,24.234,0,0,1,262.064,410.182Z",
    transform: "translate(-49.652 -255.261)",
    fill: "#b3b3b3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M275.536,393.776s-9.923,4.026-15.75,3.807a19.986,19.986,0,0,1-8.442-2.382,1.792,1.792,0,0,0-2.634,1.278l0,.065c-.084.822,0,3.337,0,3.337a18.53,18.53,0,0,0,7.688,3.954c5.626,1.413,12.011-.231,14.145-1.011s5.516,2.513,5.516,2.513l3.594-1.324S278.768,397.772,275.536,393.776Z",
    transform: "translate(-64.475 -242.59)",
    fill: "#b3b3b3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M289.9,384.937c-.42,4.318-3.083,6.467-6.039,9.1-.733,1.287-.628,5.979-.628,5.979h0c-.565.446-1.392,1.091-2.312,1.812-.315.236-.645.486-.971.736a46.738,46.738,0,0,0-3.587-10.759s3.256-2.732,7.328-6.646,4.531-5.593,4.531-5.593l-.236-.908C288.094,378.961,289.077,381.861,289.9,384.937Z",
    transform: "translate(-27.487 -262.779)",
    fill: "#b3b3b3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M173.384,356.455s.537,1.621,6.086,5.558l5.549,3.942s-11.1-6.21-12.223-8.3Z",
    transform: "translate(-165.793 -292.427)",
    fill: "#9099af"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M229.826,386.725c-.427,2.167,3.667,7.048,4.57,5.406s.983-4.052,0-4.489S230.017,385.753,229.826,386.725Z",
    transform: "translate(-89.677 -252.445)",
    fill: "#1a1a1a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M274.588,421.658c-1.039-.883-3.062-2.7-5.007-2.7a6.619,6.619,0,0,0-1.616.329c-1.509.554-3.328.815-7.121.815a18.582,18.582,0,0,1-4.507-.514,21.078,21.078,0,0,1-7.039-3.066c-.023-.941-.063-1.826-.021-2.263a.452.452,0,0,1,.469-.376.513.513,0,0,1,.248.063,21.271,21.271,0,0,0,9.01,2.534c.171.007.343.009.518.009,6.063,0,14.769-3.618,15.161-3.776.332-.161,23.928-12.039,37.637-22.216l-.348.117c.694-.381,2.5-1.777,7.8-6.866a35.9,35.9,0,0,0,3.263-3.522c.229.757.472,1.59.705,2.447-.357,2.457-2.546,4.367-4.157,5.771a8.275,8.275,0,0,0-1.728,1.784c-.736,1.287-.82,4.673-.8,6.609l-1.1.866a41.869,41.869,0,0,0-1.455-4.65l-.11-.292-.227-.212c-.268-.248-.444-.39-.444-.39l-.792-.638-.82.6c-12.3,9.129-31.8,19.1-35.815,21.124l-2.536,1.273.533,1.154a26.2,26.2,0,0,1,1.763,5.448Z",
    transform: "translate(-63.685 -260.687)",
    fill: "#f0f0f0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(58.534 40.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M260.469,387.85l-1.329-1.362c-.021-.04-2.24-4.152-13.968-12.177-9.633-6.59-33.158-22.156-43.494-24.314-6.112-1.277-6.817-2.095-6.817-2.6,0-.56.962-.792,1.156-.831l.07.332c-.374.079-.885.294-.885.5s.472,1,6.544,2.265c10.4,2.17,33.966,17.763,43.618,24.365,11.49,7.861,13.86,11.9,14.066,12.277l1.282,1.305Z",
    transform: "translate(-194.861 -346.57)",
    fill: "#9099af"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(120.672 9.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M284.789,370.3c-2.964-3.87-11.441-10.6-20.614-16.376-8.487-5.339-33.37-19.615-39.132-20.119a28.5,28.5,0,0,0-3.37-.222l-.049-.161-.114.131-.042-.2c.058-.138.086-.2,3.606.107,5.9.521,30.493,14.643,39.281,20.173,9.2,5.792,17.719,12.56,20.7,16.457Z",
    transform: "translate(-221.468 -333.242)",
    fill: "#9099af"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarlogo3);
export default __webpack_public_path__ + "static/media/carlogo3.d3bbcf4ff7f895b20648e9211253841a.svg";
export { ForwardRef as ReactComponent };